<template>
    <v-container>
        <v-layout row>
            <v-flex ref="fileForm">
                <v-card v-if="files.length > 0" class="grey lighten-4 uploader" data-cy="dropzone">
                    <v-list class="grey lighten-4 pt-2 px-2">
                        <template v-for="(file, index) in files">
                            <v-list-item class="grey lighten-4" :key="index">
                                <v-list-item-action>
                                    <v-btn icon @click="removeFile(index)">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                                <v-list-item-content>{{ file.name }}<br /></v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>
                <v-card v-else class="grey lighten-4 uploader" data-cy="dropzone">
                    <h3 class="uploader-text">Drag and Drop Files for Upload</h3>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout v-if="uploading">
            <v-flex xs4>
                <v-progress-linear v-model="uploadProgress" height="20"></v-progress-linear>
            </v-flex>
        </v-layout>
        <!-- the actual file input is hidden off screen -->
        <input type="file" ref="files" multiple @change="addFiles($refs.files.files)" />

        <v-layout row fill-height class="d-flex justify-space-between my-3 pr-1">
            <v-btn @click="$refs.files.click()">Select files from computer</v-btn>
            <span> {{ this.files.length }} / 30 Files for Upload </span>
        </v-layout>
    </v-container>
</template>

<style>
input[type='file'] {
    position: absolute;
    top: -500px;
}

.uploader {
    min-height: 150px;
    border: 2px solid #000;
    outline: 1px dashed #000;
    outline-offset: -10px;
}

.uploader-text {
    text-align: center;
    line-height: 150px;
}
</style>

<script>
export default {
    props: ['files'],
    data() {
        return {
            dragAndDropCapable: false,
            dragging: false,
            uploading: false,
            uploadProgress: 0,
            fileError: false
        }
    },
    methods: {
        addFiles(uploadedFiles) {
            for (let i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i])
            }
            this.$emit('fileUploadList', this.files)
        },
        removeFile(index) {
            this.files.splice(index, 1)

            this.$emit('fileUploadList', this.files)
        },
        determineDragAndDropCapable() {
            // Create a test element to see if the browser supports drag/drop
            var div = document.createElement('div')

            /*
                Check to see if the `draggable` event is in the element
                or the `ondragstart` and `ondrop` events are in the element. If
                they are, then we have what we need for dragging and dropping files.

                We also check to see if the window has `FormData` and `FileReader` objects
                present so we can do our AJAX uploading
            */
            return (
                ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
                'FormData' in window &&
                'FileReader' in window
            )
        }
    },
    computed: {
        documentUploadUrl: function() {
            return this.store.state.jobDocumentUploadUrl
        }
    },
    mounted() {
        // Determine if drag and drop functionality is capable in the browser
        this.dragAndDropCapable = this.determineDragAndDropCapable()

        // If drag and drop capable, then we continue to bind events to our elements.
        if (this.dragAndDropCapable) {
            // Listen to all of the drag events and bind an event listener to each for the fileform.
            ;['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(
                function(evt) {
                    // For each event add an event listener that prevents the default action
                    // (opening the file in the browser) and stop the propagation of the event (so
                    // no other elements open the file in the browser)
                    this.$refs.fileForm.addEventListener(
                        evt,
                        function(e) {
                            e.preventDefault()
                            e.stopPropagation()
                            if (evt === 'drag') {
                                this.dragging = true
                            }
                        }.bind(this),
                        false
                    )
                }.bind(this)
            )

            // Add an event listener for drop to the form
            this.$refs.fileForm.addEventListener(
                'drop',
                function(e) {
                    // Capture the files from the drop event and add them to our local files array.
                    this.addFiles(e.dataTransfer.files)
                }.bind(this)
            )
        }
    },
    watch: {
        uploadProgress: function() {
            if (this.uploadProgress > 0) {
                this.uploading = true
            } else {
                this.uploading = false
            }
        }
    }
}
</script>
